import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface NotifyDialogData {
  message: string;
}

@Component({
  selector: 'app-notify-popup',
  templateUrl: './notify-popup.component.html',
  styleUrls: ['./notify-popup.component.scss'],
  standalone: false
})
export class NotifyPopupComponent {
  private dialogRef = inject<MatDialogRef<NotifyPopupComponent>>(MatDialogRef);
  data = inject<NotifyDialogData>(MAT_DIALOG_DATA);

  close(): void {
    this.dialogRef.close();
  }
}
